<template>
  <el-dialog :before-close="closeDialog" width="600px" :visible.sync="walletDialog" :title="title">
    <div class="dialog_box">
      <!-- 提现 -->
      <div class="dialog_block" v-if="type == 0">
        <div v-if="status == 0">
          <el-form ref="CashForms" v-bind:model="CashForm" label-position="right" label-width="100px">
            <div class="dl_row">
              <div class="dl_label">
                <!-- {{ $t("enum.balance") }} -->
                {{ $t("enum.accountBalance") }}
              </div>
              <div class="dl_val">
                <span class="br_ov">
                  {{ walletInfo.Currency }}
                  <b class="br_ov_amount">
                    {{ walletInfo.AvailableAmount > 0 ? $store.getters.thousandAndDecimal(walletInfo.AvailableAmount) : walletInfo.AvailableAmount }}
                  </b>
                </span>
                <!-- <span class="cash-all" v-on:click="cashAll">{{ $t("enum.takeCashAll") }}</span> -->
              </div>
            </div>
            <div class="dl_rowww" v-show="false">
              <el-form-item class="waller_fitem" :label="$t('enum.takeAmount')" required prop="Amount" :rules="formRule(1, 'Amount', '提现金额')">
                <el-input class="wallet_input" type="number" readonly :autofocus="true" v-model="CashForm.Amount" :min="minCashAmount" :max="walletInfo.AvailableAmount" placeholder="请输入提现金额"></el-input>
              </el-form-item>
            </div>
            <!-- <div class="dl_row">
              <div class="dl_label">提现至：</div>
              <div class="dl_val">{{ walletInfo.TransferAccounts[0] ? walletInfo.TransferAccounts[0].TransferAccountTypeName : '-' }}</div>
            </div> -->
            <div class="dl_row aitem_left">
              <div class="dl_label">{{ $t('enum.wdNotice') }}</div>
              <div class="dl_val">
                <div v-html="$t('enum.withdrawnNotice', [minCashAmount, feeAmount])"></div>
              </div>

            </div>
          </el-form>
        </div>
        <div class="deposit" v-if="status == 1">
          <div class="dl_status_box">
            <i slot="reference" class="wallet-success el-icon-circle-check"></i>
            <div class="wallet-tips">
              <!-- <div class="status_label">{{ $t('enum.takeProcessing') }}</div> -->
            </div>
          </div>
        </div>
      </div>
      <!-- 转账 -->
      <!-- .... -->
    </div>
    <span slot="footer" class="dialog-footer">
      <div v-if="type == 0 && status == 0" class="operate_c" style="text-align: right;">
        <el-button @click="closeDialog()">{{ $t('button.cancel') }}</el-button>
        <el-button class="apply" type="primary" :disabled="loading || CashForm.Amount < minCashAmount || CashForm.Amount > walletInfo.AvailableAmount ? true : false" :loading="loading" @click="TakeCash">{{ $t('button.withdraw') }}</el-button>
      </div>
      <div v-if="type == 0 && status == 1" class="operate_r" style="text-align: center;">
        <el-button class="apply" type="primary" @click="closeDialog('getList')">{{ $t('button.confirm') }}</el-button>
      </div>
    </span>
  </el-dialog>
</template>

<script>

export default {
  name: 'Dashboard',
  components: {},
  props: {
    walletDialog: Boolean,
    type: Number,//0 提现
    walletInfo: Object
  },
  data() {
    return {
      title: this.$t("enum.takeCash"),
      loading: false,
      status: 0,//0提现申请，1提现申请提交成功
      minCashAmount: process.env.NODE_ENV === "production" ? 3 : 7,//最低提现金额
      feeAmount: process.env.NODE_ENV === "production" ? 1 : 3,//手续费
      CashForm: {
        Amount: this.walletInfo.AvailableAmount,//process.env.NODE_ENV === "production" ? 7 : 7,
        MemberId: this.$store.state.UserInfo.MappingUserId
      }
    }
  },

  computed: {
    formRule: function () {
      var that = this;
      return function (required, ControlName, name) {
        var r = [];
        var exg = /(^[1-9]{1}[0-9]*$)|(^[0-9]*\.[0-9]{1,2}$)/;//大于0且保留小数两位
        //console.log("formRule", required, ControlName, name);
        if (required) {
          if (ControlName == 'Amount') {
            r = [
              {
                validator: function (rule, value, callback) {
                  var _val = that.CashForm.Amount ? that.CashForm.Amount : '';
                  if (!_val || parseFloat(_val) < that.minCashAmount) {
                    callback(new Error(that.$t('tips.miniAmount', [that.walletInfo.Currency + ' ' + that.minCashAmount])));
                  }
                  else if (parseFloat(_val) > parseFloat(that.walletInfo.AvailableAmount)) {
                    callback(new Error(that.$t('tips.maxAmount', [that.walletInfo.Currency + ' ' + that.walletInfo.AvailableAmount])));
                  }
                  else if (!exg.test(parseFloat(_val))) {
                    callback(new Error(that.$t('tips.priceTwoDec')));
                  }
                  else {
                    // 验证通过
                    callback();
                  }
                }, trigger: ['change', 'blur']
              }
            ];
          } else {
            r = [
              {
                validator: function (rule, value, callback) {
                  var _val = that.FormData[ControlName] ? that.FormData[ControlName] : '';
                  if (!_val) {
                    callback(new Error(that.$t('tips.plsFillIn', [name])));
                  } else {
                    // 验证通过
                    callback();
                  }
                }, trigger: ['change', 'blur']
              }
            ];
          }
        }
        return r;
      }
    },
  },
  watch: {
    type(newValue, oldValue) {
      if (newValue == 0) {
        this.title = this.$t("enum.takeCash")
      }
      else {
        this.title = '提现'//转账、、、
      }
      this.type = newValue
    }
  },
  created() { },
  methods: {
    // 提现
    TakeCash() {
      var that = this
      if (!that.loading) {
        that.loading = true;
        that.$post('TakeCash', that.CashForm, 'WalletApi')
          .then((res) => {
            if (res.Result) {
              that.$message.success(res.Msg || that.$t("tips.successful"));
              that.closeDialog('getList')
              // that.status = 1;
            } else {
              that.$message.error(res.Msg || that.$t("tips.fail"));
              that.loading = false;
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }

    },
    cashAll() {
      this.CashForm.Amount = this.walletInfo.AvailableAmount;
    },
    // 调用父级关闭弹框事件
    closeDialog(type) {
      var data = type == 'getList' ? { type: 'getList' } : {}
      this.$emit('closeDialog', data)
    }
  }
}
</script>

<style scoped>
.dialog_box {
  width: 85%;
}

.dl_row {
  display: flex;
  flex-direction: column;
  align-content: center;
  align-items: center;
  justify-content: center;
  line-height: 1.6;
  font-size: 14px;
  padding-bottom: 10px;
}

.aitem_left {
  align-items: flex-start;
}

.icon-more {
  font-size: 16px;
}

.flex-row {
  display: flex;
  flex-direction: row;

}

.flex-between {
  justify-content: space-between;
}

.dl_label {
  font-weight: bold;
}

.dl_val {
  color: #333;
}

.dl_val p {
  word-wrap: break-word;
}

.br_ov {
  display: block;
  font-size: 16px;
  padding: 5px 0;
}

.br_date {
  color: #A0A0A0;
}

.br_ov_amount {
  font-size: 36px;
  color: #5F6DAE;
}

.cash-all {
  cursor: pointer;
  font-size: 12px;
  margin: 0 10px;
}

.dl_status_box {
  display: flex;
  justify-content: center;
  flex-direction: column;
  line-height: 2;
  align-items: center;
}

.icon_success {
  width: 100px;
  display: block;
  margin: 0 auto 20px;
}

.status_label {
  color: #333333;
  font-size: 14px;
  font-weight: bold;
}

.status_val {
  font-size: 12px;
}

.wallet-success {
  font-size: 52px;
  color: #5f6dae;
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/wallet-operate.vue